// src/components/Header.jsx
import React from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <header className="flex justify-between items-center h-16 px-6 bg-white border-b z-30">
      {/* LOGO ONLY — Clickable */}
      <div
        className="flex items-center cursor-pointer"
        onClick={() => navigate("/dashboard")}
      >
        <img
          src="/assets/logo/mdih-no-tm.png"
          alt="MDIH"
          className="h-36 w-auto object-contain"
        />
      </div>

      {/* RIGHT ACTIONS */}
      <div className="flex items-center gap-4">
        {!user ? (
          <>
            <button
              className="text-blue-600 font-semibold text-sm hover:underline"
              onClick={() => navigate("/login")}
            >
              Login
            </button>
            <button
              className="bg-blue-600 text-white px-4 py-1.5 rounded-md text-sm font-semibold hover:bg-blue-700"
              onClick={() => navigate("/register")}
            >
              Sign Up
            </button>
          </>
        ) : (
          <>
            <span className="text-sm text-slate-700 font-medium">
              {user.name}
            </span>
            <button
              className="bg-red-500 text-white px-4 py-1.5 rounded-md text-sm font-semibold hover:bg-red-600"
              onClick={handleLogout}
            >
              Logout
            </button>
          </>
        )}
      </div>
    </header>
  );
};

export default Header;